import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'Employee report',
    component: () => import('./view/reports/reports-employee')
  },
  {
    path: '/reports/team',
    name: 'Team report',
    component: () => import('./view/reports/reports-team')
  },
  {
    path: '/reports/company',
    name: 'Company report',
    component: () => import('./view/reports/reports-company')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('./view/contacts/contacts-list')
  },
]
